import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M21.188 9.281L27.907 16l-6.719 6.719-1.406-1.438L24.063 17H4v-2h20.063l-4.281-4.281z" /></svg>);